import React, { useState, useEffect } from 'react';
import SupportWidget from './components/SupportWidget';
import { getWidgetConfig } from './utils/api';

// When loaded as an iframe (embed=true), render ONLY the widget (no chrome).
// Identity + styling come from URL query params set by the host page.
function parseQuickReplies(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.map((x) => String(x));
  } catch (e) {
    /* not JSON */
  }
  return raw.split(',').map((x) => x.trim()).filter(Boolean);
}

function getQuery() {
  const params = new URLSearchParams(window.location.search);
  return {
    role: params.get('role') || 'employee',
    userId: params.get('userId') || 'guest',
    orgId: params.get('orgId') || '',
    token: params.get('token') || '',
    accent: params.get('accent') || '#667eea',
    embed: params.get('embed') === 'true',
    quickReplies: parseQuickReplies(params.get('quickReplies')),
  };
}

function App() {
  const [cfg] = useState(getQuery);
  const [runtime, setRuntime] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getWidgetConfig()
      .then((c) => { if (!cancelled) setRuntime(c); })
      .catch(() => { /* widget keeps its built-in defaults */ });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!cfg.embed) return;
    // Brand accent
    const hex = cfg.accent;
    document.documentElement.style.setProperty('--sw-accent', hex);
    document.documentElement.style.setProperty('--sw-accent2', shade(hex, -20));
    // Make the page transparent + full so the iframe overlays cleanly
    document.body.style.margin = '0';
    document.body.style.background = 'transparent';
    document.documentElement.style.background = 'transparent';
  }, [cfg]);

  if (cfg.embed) {
    const roleOpts = runtime && runtime.quick_replies && runtime.quick_replies[cfg.role];
    const quickReplies = cfg.quickReplies || (Array.isArray(roleOpts) && roleOpts.length ? roleOpts : undefined);
    return (
      <SupportWidget
        userRole={cfg.role}
        userId={cfg.userId}
        orgId={cfg.orgId}
        token={cfg.token}
        quickReplies={quickReplies}
        greeting={runtime ? runtime.greeting : undefined}
      />
    );
  }

  return (
    <div style={{ fontFamily: 'sans-serif', textAlign: 'center', marginTop: '100px', color: '#333' }}>
      <h1>Employee Benefits Support Agent</h1>
      <p>Demo page. Click the chat bubble to start.</p>
      <SupportWidget userRole="employee" userId="demo-user-001" />
    </div>
  );
}

function shade(hex, percent) {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const r = Math.min(255, Math.max(0, (num >> 16) + amt));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + amt));
  const b = Math.min(255, Math.max(0, (num & 0x0000ff) + amt));
  return `#${(0x1000000 + r * 0x10000 + g * 0x100 + b).toString(16).slice(1)}`;
}

export default App;
